import styled from "@emotion/styled";

import { fontRoboto, theme } from "shared/lib/styles";

import { Indicator } from "scmp-app/components/my-news/indicator";

import InfoIcon from "./info-icon.svg";
import MynewsLogo from "./logo-mynews.svg";

export const Container = styled.div`
  margin-block: 24px;
  margin-inline: 0;

  text-align: center;
  ${theme.breakpoints.up("tablet")} {
    margin-block: 32px;
    margin-inline: 0;
  }
`;

export const Wrapper = styled.div`
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  block-size: 46px;
  margin-block-end: 4px;
  ${theme.breakpoints.up("tablet")} {
    margin-block: 0 12px;
    margin-inline: auto;
  }
`;

export const LogoMynews = styled(MynewsLogo)`
  inline-size: 85.63px;
  block-size: 22.95px;
  ${theme.breakpoints.up("tablet")} {
    inline-size: 167px;
    block-size: 46px;
  }
`;

export const IconInfoContainer = styled.div`
  display: inline-block;

  inline-size: 16px;
  block-size: 16px;
  margin-block-end: 1px;
  margin-inline-start: 1px;

  vertical-align: middle;

  cursor: pointer;
  ${theme.breakpoints.up("tablet")} {
    inline-size: 28px;
    block-size: 28px;
    margin-inline-start: 4px;

    cursor: auto;
  }
`;

export const IconInfo = styled(InfoIcon)`
  inline-size: 16px;
  block-size: 16px;
  ${theme.breakpoints.up("tablet")} {
    inline-size: 28px;
    block-size: 28px;
  }
`;

export const IndicatorWrapper = styled.div`
  position: relative;
`;

export const StyledIndicator = styled(Indicator)`
  display: none;
  ${theme.breakpoints.up("tablet")} {
    inset-block-start: 77%;
    inset-inline-end: -15px;

    display: block;

    margin-block-start: 33px;
  }
  ${theme.breakpoints.up("desktop")} {
    inset-block-start: -29px;
    inset-inline-start: 100%;

    margin-block-start: 0;
    margin-inline-start: 20px;
  }
`;

export const Description = styled.div`
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 19.6px;
  ${theme.breakpoints.up("tablet")} {
    font-size: 16px;
    line-height: 22.4px;
  }
`;
